
// lazySizesConfig.preloadAfterLoad = true;
window.lazySizesConfig = window.lazySizesConfig || {};


// sync breakpoints between CSS and the media attributes of "picture > source" elements
window.lazySizesConfig.customMedia;
